import React, { useState, useEffect } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
// import Header from './component/Header';
import Footer from './component/Footer';
import { fetchSections } from './services/userProfile';
import api from './api';

const ProductListing = () => {
    // const navigate = useNavigate();
    const offers = useLocation();

    const { title, slug, poster } = offers.state || {};

    console.log("ofers____", offers);

    // const [sections, setSections] = useState([]);
    const location = useLocation();
    const { categoryId } = useParams();
    const { sections, setSections } = location.state || {};
    console.log("sectioncsastttt", sections);

    const [isVisible, setIsVisible] = useState(false);
    const [loading, setLoading] = useState(true);

    // Show button after scrollY > 300
    useEffect(() => {
        const handleScroll = () => {
            setIsVisible(window.scrollY > 300);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Smooth scroll to top
    const handleScrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const [selectedCategory, setSelectedCategory] = useState(1);
    const [selectedValue, setSelectedValue] = useState("1");
    const handleChange = (event) => {
        setSelectedCategory(event.target.value);
    };
    const [quantity, setQuantity] = useState(1);
    const [inputValue, setInputValue] = useState(1);
    const [isChecked, setIsChecked] = useState(false);

    const [selectedColor, setSelectedColor] = useState('');
    const [selectedWeight, setSelectedWeight] = useState('');
    const [sortValue, setSortValue] = useState("1");

    const handleSortChange = (e) => {
        setSortValue(e.target.value);
    };

    const handleColorChange = (event) => {
        setSelectedColor(event.target.value);
    };

    const handleWeightChange = (event) => {
        setSelectedWeight(event.target.value);
    };

    // const sectionCategory = async () => {
    //     try {
    //         const res = await fetchSections();
           
    //         setSections(res.data.data);
    //     } catch (error) {
    //         console.log("error", error.message);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // useEffect(() => {
    //     setLoading(true); 
    //     sectionCategory();
    // }, []);

    useEffect(() => {
        setLoading(true);
        const fetchSections = async () => {
            try {
                const res = await api.get("/user/getSections");
                setSections(res.data.data);
                console.log("section id name".res.data.data);
            } catch (err) {
                console.log("Failed to fetch sections", err);
            }

        };
        fetchSections();
    }, []);

    return (

        <>

            {/* <!-- Start preloader --> */}

            {/* <!-- End preloader -->

            <!-- Start header area --> */}
            {/* <Header /> */}
            {/* <!-- End header area --> */}


            <main className="main__content_wrapper">

                {/* <!-- Start breadcrumb section --> */}
                <section className="breadcrumb__section breadcrumb__bg">
                    <div className="container">
                        <div className="row row-cols-1">
                            <div className="col">
                                <div className="breadcrumb__content text-left">
                                    <h1 className="breadcrumb__content--title text-white mb-25">Shop</h1>
                                    <ul className="breadcrumb__content--menu d-flex justify-content-left">
                                        <li className="breadcrumb__content--menu__items"><Link className="text-white" to="/">Home</Link></li>
                                        <li className="breadcrumb__content--menu__items"><span className="text-white">Shop</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- End breadcrumb section -->

            <!-- Start shop section --> */}
                <section className="shop__section section--padding" style={{ paddingTop: '3rem', paddingBottom: '0rem' }}>
                    <div className="container-fluid">
                        {/* <div className="shop__header bg__gray--color d-flex align-items-center justify-content-between mb-30">
                            <button className="widget__filter--btn d-flex d-lg-none align-items-center" data-offcanvas>
                                <svg className="widget__filter--btn__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="28" d="M368 128h80M64 128h240M368 384h80M64 384h240M208 256h240M64 256h80" /><circle cx="336" cy="128" r="28" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="28" /><circle cx="176" cy="256" r="28" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="28" /><circle cx="336" cy="384" r="28" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="28" /></svg>
                                <span className="widget__filter--btn__text">Filter</span>
                            </button>
                            <div className="product__view--mode d-flex align-items-center">
                                <div className="product__view--mode__list product__short--by align-items-center d-none d-lg-flex">
                                    <label className="product__view--label">Prev Page :</label>
                                    <div className="select shop__header--select">
                                        <select className="product__view--select" value={selectedValue} onChange={handleChange}>
                                            <option value="1">65</option>
                                            <option value="2">40</option>
                                            <option value="3">42</option>
                                            <option value="4">57</option>
                                            <option value="5">60</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="product__view--mode__list product__short--by align-items-center d-none d-lg-flex">
                                    <label className="product__view--label">Sort By :</label>
                                    <div className="select shop__header--select">
                                        <select className="product__view--select" value={sortValue} onChange={handleSortChange}>
                                            <option value="1">Sort by latest</option>
                                            <option value="2">Sort by popularity</option>
                                            <option value="3">Sort by newness</option>
                                            <option value="4">Sort by rating</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="product__view--mode__list product__view--search d-none d-lg-block">
                                    <form className="product__view--search__form" action="#">
                                        <label>
                                            <input className="product__view--search__input border-0" placeholder="Search by" type="text" />
                                        </label>
                                        <button className="product__view--search__btn" aria-label="shop button" type="submit">
                                            <svg className="product__view--search__btn--svg" xmlns="http://www.w3.org/2000/svg" width="22.51" height="20.443" viewBox="0 0 512 512"><path d="M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="32" /><path fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="32" d="M338.29 338.29L448 448" /></svg>
                                        </button>
                                    </form>
                                </div>
                            </div>
                            <p className="product__showing--count">Showing 1–9 of 21 results</p>
                        </div> */}

                    </div>
                </section>
                {/* <!-- End shop section --> */}


                <section className="product__section section--padding pt-0">
                    <div className="container-fluid">
                        <div className="tab_content">
                            <div id="featured" className="tab_pane active show">
                                <div className="product__section--inner">
                                    <div className="row mb--n30">
                                        <div className="col-12">
                                            {sections?.categories?.length > 0 && (
                                                <div className="row">
                                                    {sections.categories.map((cat) => (
                                                        <div
                                                            key={cat._id}
                                                            className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-4 text-center"
                                                        >
                                                            <Link
                                                                to={`/product-category-list/${cat._id}`}
                                                                className="text-decoration-none"
                                                            >
                                                                <div
                                                                    className="card border-0 shadow-sm"
                                                                    style={{
                                                                        aspectRatio: "3 / 4",
                                                                        height: "100%",
                                                                        overflow: "hidden",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={cat.image}
                                                                        alt={cat.name}
                                                                        className="img-fluid"
                                                                        style={{
                                                                            width: "100%",
                                                                            height: "100%",
                                                                            objectFit: "cover",
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="mt-2">
                                                                    <p className="fw-semibold text-dark mb-0">
                                                                        {cat.name}
                                                                    </p>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                            {/* {
                                offers?.pathname?.split("/")[2]
                            } */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


            </main>

            {/* <!-- Start footer section --> */}
            <Footer />
            {/* <!-- End footer section -->

            <!-- Scroll top bar --> */}
            <button
                onClick={handleScrollTop}
                style={{
                    position: 'fixed', bottom: '30px', right: '30px', width: '50px', height: '50px', borderRadius: '50%', backgroundColor: '#ceb256', color: '#fff', border: 'none', zIndex: 1000, cursor: 'pointer', display: isVisible ? 'flex' : 'none', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                }}>
                {/* Up Arrow SVG Icon */}
                <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth="48" strokeLinecap="round" strokeLinejoin="round" >
                    <path d="M112 244l144-144 144 144" />
                    <path d="M256 120v292" />
                </svg>
            </button>




        </>
    )
}

export default ProductListing;
